import { api } from './api'
import { forgetFamily } from './frame'
import { forgetOfflineCopies } from './offline'

// Switching who the app is for (the owner viewing as a test person, or back): like signing out and in, everything
// kept for the last person is forgotten and the app starts again from Home.
async function restart() {
  await forgetOfflineCopies()
  forgetFamily()
  window.location.assign('/')
}

export async function viewAsTestPerson(id: string) {
  await api(`/admin/test-people/${encodeURIComponent(id)}/view`, { method: 'POST' })
  await restart()
}

export async function stopViewingAs() {
  await api('/view-as', { method: 'DELETE' })
  await restart()
}
